import { Box, Paper, Typography } from "@mui/material";
import { WarningAmberOutlined } from "@mui/icons-material";

/**
 * Vista de respaldo cuando no se encuentra la configuración del tab (`tabs_bofu_config`) de la solicitud:
 * le indica al usuario que contacte al administrador en lugar de mostrar el expediente vacío.
 */
export const PaperConfigMissing = () => (
  <Paper variant="lendia_paper" sx={{ p: "40px 28px", textAlign: "center" }} data-testid="expediente-config-missing">
    <Box
      sx={{
        width: 52,
        height: 52,
        borderRadius: "50%",
        bgcolor: "#FFF8EC",
        color: "warning.main",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mx: "auto",
        mb: 2,
      }}
    >
      <WarningAmberOutlined sx={{ fontSize: 26 }} />
    </Box>
    <Typography variant="body1" sx={{ fontWeight: 600, color: "primary.dark" }}>
      No pudimos cargar la configuración de tu expediente
    </Typography>
    <Typography variant="body2" sx={{ color: "text.disabled", mt: "8px" }}>
      Contacta al administrador para que valide la configuración de documentos de tu solicitud.
    </Typography>
  </Paper>
);
